import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClientContainerComponent } from './client-container.component';

const routes: Routes = [
  {
    path: '',
    component: ClientContainerComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
          import('./client-dashboard/client-dashboard.module').then(
            (m) => m.ClientDashboardModule
          ),
      },
      {
        path: 'perfil',
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
          import('./profile/profile.module').then((m) => m.ProfileModule),
      },
      {
        path: 'visit-detail',
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
          import('./visit-detail/visit-detail.module').then(
            (m) => m.VisitDetailModule
          ),
      },
      {
        path: 'calificacion',
        loadChildren: () =>
          import('./qualification/qualification.module').then(
            (m) => m.QualificationModule
          ),
      },
      {
        path: 'video-visita',
        loadChildren: () =>
          import('../../end-of-visit-video/end-of-visit-video.module').then(
            (m) => m.EndOfVisitVideoModule
          ),
      },
      {
        path: 'call-abandonment-alert',
        loadChildren: () =>
          import('./call-abandonment-alert/call-abandonment-alert.module').then(
            (m) => m.CallAbandonmentAlertModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClientContainerRoutingModule {}
